<template>
  <span v-if="imgList!=null">
    <viewer :images="listJsonToList(imgList,'url')">
	   <img v-for="o in imgList" :src="o.url" :width="width" :height="height">
	  </viewer>
      <!--<img v-for="(img,index) in imgList"-->
      <!--:key="index"-->
      <!--preview-title-enable="true"-->
      <!--preview-nav-enable="true" v-preview="img.url" :src="img.url" width="40" height="40"-->
      <!--style="margin-right: 5px"/>-->
  </span>
</template>
<script>

    export default {
        data() {
            return {};
        },
        props: {
            imgList: null,
            width: {default: 40},
            height: {default: 40},
            name: null,
        }
    }
</script>



// WEBPACK FOOTER //
// src/kc/keTemp/imgView.vue